<template>
  <div class="dyeingAndFinishingOrderDetail">
    <div class="header">
      <div class="header_title">
        <div class="block"></div>
        <div>跟单详情</div>
      </div>
      <div class="header_message">
        <div class="header_right">
          <div>当前状态</div>
          <div>{{ chooseStatus() }}</div>
        </div>
      </div>
    </div>
    <div class="steps">
      <!-- 胚布确认 -->
      <div class="grey" v-if="grepclothComfir.ztdpoContractNo">
        <div class="steps_line">
          <div class="steps_title">1.胚布确认</div>
          <div class="steps_title">跟单员：{{ grepclothComfir.ztdpoMerchandiser || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground">订单号</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoContractNo
                  ? grepclothComfir.ztdpoContractNo
                  : "-"
              }}
            </td>
            <td class="greyBackground">货号</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoArticleNumber
                  ? grepclothComfir.ztdpoArticleNumber
                  : "-"
              }}
            </td>
            <td class="greyBackground">胚布货号</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoGreyFabricNumber1
                  ? grepclothComfir.ztdpoGreyFabricNumber1
                  : "-"
              }}
            </td>
            <td class="greyBackground">加工单号</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoDyeingOrderNumber
                  ? grepclothComfir.ztdpoDyeingOrderNumber
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">染厂</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoCompanyName
                  ? grepclothComfir.ztdpoCompanyName
                  : "-"
              }}
            </td>
            <td class="greyBackground">制单日期</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoFormDate
                  ? grepclothComfir.ztdpoFormDate
                  : "-"
              }}
            </td>
            <td class="greyBackground">交货日期</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoOrderDeliveryDate
                  ? grepclothComfir.ztdpoOrderDeliveryDate
                  : "-"
              }}
            </td>
            <td class="greyBackground">条距</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoBarSpacing
                  ? grepclothComfir.ztdpoBarSpacing
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">品名</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoProductName
                  ? grepclothComfir.ztdpoProductName
                  : "-"
              }}
            </td>
            <td class="greyBackground">门幅</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdgcpLarghezza
                  ? grepclothComfir.ztdgcpLarghezza
                  : "-"
              }}
            </td>
            <td class="greyBackground">克重</td>
            <td>
              {{ grepclothComfir && grepclothComfir.ztdgcpGram ? grepclothComfir.ztdgcpGram : "-" }}
            </td>
            <td class="greyBackground">确认条距</td>
            <td colspan="3">
              {{
                grepclothComfir && grepclothComfir.ztdgcpSliverSpacing
                  ? grepclothComfir.ztdgcpSliverSpacing
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">成分</td>
            <td colspan="8">
              {{
                grepclothComfir && grepclothComfir.ztdpoIngredients
                  ? grepclothComfir.ztdpoIngredients
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" rowspan="2">工厂颜色</td>
            <td rowspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoiFactoryColor
                  ? grepclothComfir.ztdpoiFactoryColor
                  : "-"
              }}
            </td>
            <td class="greyBackground" rowspan="2">工厂色号</td>
            <td rowspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoiFactoryColorNumber
                  ? grepclothComfir.ztdpoiFactoryColorNumber
                  : "-"
              }}
            </td>
            <td class="greyBackground" rowspan="2">需求数(KGS)</td>
            <td rowspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoiContractWeight
                  ? grepclothComfir.ztdpoiContractWeight
                  : "-"
              }}
            </td>
            <td class="greyBackground" rowspan="2">投胚数量</td>
            <td class="greyBackground">匹数(匹)</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoiClothQuantity
                  ? grepclothComfir.ztdpoiClothQuantity
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">重量(KG)</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoiPutInWeight
                  ? grepclothComfir.ztdpoiPutInWeight
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 松布缝头 -->
      <div class="reserve">
        <div class="steps_line">
          <div class="steps_title">2.松布缝头</div>
          <div class="steps_title">跟单员：{{ grepclothComfir.ztdpoMerchandiser || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否松布缝头</td>
            <td colspan="8">
              是
            </td>
          </tr>
        </table>
      </div>
      <!-- 汽平 -->
      <div class="reserve" v-if="qp.qiPingInfo">
        <div class="steps_line">
          <div class="steps_title">3.汽平</div>
          <div class="steps_title">跟单员：{{ qp.qiPingInfo.ztdqpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground">上机参数</td>
            <td class="greyBackground">车速</td>
            <td colspan="3">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpUpSpeed ? qp.qiPingInfo.ztdqpUpSpeed : "-"
              }}
            </td>
            <td class="greyBackground">温度</td>
            <td colspan="3">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpSteamUpTemperature
                  ? qp.qiPingInfo.ztdqpSteamUpTemperature
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">下机参数</td>
            <td class="greyBackground">门幅</td>
            <td colspan="3">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpSteamDownLarghezza
                  ? qp.qiPingInfo.ztdqpSteamDownLarghezza
                  : "-"
              }}
            </td>
            <td class="greyBackground">克重</td>
            <td colspan="3">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpSteamDownGram
                  ? qp.qiPingInfo.ztdqpSteamDownGram
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" rowspan="2">图片</td>
            <td colspan="8" rowspan="2">
              <img
                v-for="item in qp && qp.imgList ? qp.imgList : []"
                :key="item"
                :src="baseUrl + item"
              />
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td class="greyBackground">备注</td>
            <td colspan="8 ">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpRemarks ? qp.qiPingInfo.ztdqpRemarks : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 预定 -->
      <div class="reserve" v-if="yuDingInfo.ztdypMachineSpeed">
        <div class="steps_line">
          <div class="steps_title">4.预定</div>
          <div class="steps_title">跟单员：{{ yuDingInfo.ztdypFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground">车速</td>
            <td colspan="3">
              {{ yuDingInfo && yuDingInfo.ztdypMachineSpeed ? yuDingInfo.ztdypMachineSpeed : "-" }}
            </td>
            <td class="greyBackground">温度</td>
            <td colspan="4">
              {{
                yuDingInfo && yuDingInfo.ztdypMachineTemperature
                  ? yuDingInfo.ztdypMachineTemperature
                  : "-"
              }}
            </td>
          </tr>
          <template v-for="(item, index) in JSON.parse(yuDingInfo.ztdypMachineAuxiliary)">
            <tr :key="item.auxiliary">
              <td class="greyBackground">助剂{{ index + 1 }}</td>
              <td colspan="3">{{ item.auxiliary ? item.auxiliary : "-" }}</td>
              <td class="greyBackground">助剂{{ index + 1 }}信息</td>
              <td colspan="4">{{ item.auxiliaryInfo ? item.auxiliaryInfo : "-" }}</td>
            </tr>
          </template>
          <tr>
            <td class="greyBackground" rowspan="2">上机</td>
            <td class="greyBackground">门幅(cm)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypUpMachineLarghezza
                  ? yuDingInfo.ztdypUpMachineLarghezza
                  : "-"
              }}
            </td>
            <td class="greyBackground" rowspan="2">定中</td>
            <td class="greyBackground">门幅(cm)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypMiddleMachineLarghezza
                  ? yuDingInfo.ztdypMiddleMachineLarghezza
                  : "-"
              }}
            </td>
            <td class="greyBackground" rowspan="2">下机</td>
            <td class="greyBackground">门幅(cm)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypDownMachineLarghezza
                  ? yuDingInfo.ztdypDownMachineLarghezza
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">克重(GSM)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypUpMachineGram ? yuDingInfo.ztdypUpMachineGram : "-"
              }}
            </td>
            <td class="greyBackground">克重(GSM)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypMiddleMachineGram
                  ? yuDingInfo.ztdypMiddleMachineGram
                  : "-"
              }}
            </td>
            <td class="greyBackground">克重(GSM)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypDownMachineLarghezza
                  ? yuDingInfo.ztdypDownMachineLarghezza
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" rowspan="2">图片</td>
            <td colspan="8" rowspan="2">
              <img
                v-for="item in imgList && imgList.imgList_yd ? imgList.imgList_yd : []"
                :key="item"
                :src="baseUrl + item"
              />
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td class="greyBackground">备注</td>
            <td colspan="8 ">
              {{ yuDingInfo && yuDingInfo.ztdypRemarks ? yuDingInfo.ztdypRemarks : "-" }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 前处理 -->
      <div class="reserve" v-if="qcl.qianChuLiInfo">
        <div class="steps_line">
          <div class="steps_title">5.前处理</div>
          <div class="steps_title">跟单员：{{ qcl.qianChuLiInfo.ztdqpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground">是否烧毛</td>
            <td colspan="3">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpShaomao
                  ? qcl.qianChuLiInfo.ztdqpShaomao == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
            <td class="greyBackground">是否蚀毛</td>
            <td colspan="3">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpShimao
                  ? qcl.qianChuLiInfo.ztdqpShimao == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
            <td class="greyBackground">是否丝光</td>
            <td colspan="3">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpSiguang
                  ? qcl.qianChuLiInfo.ztdqpSiguang == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">备注</td>
            <td colspan="9">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpRemark
                  ? qcl.qianChuLiInfo.ztdqpRemark
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 染色 -->
      <div class="reserve" v-if="rs.ranSeInfo">
        <div class="steps_line">
          <div class="steps_title">6.染色</div>
          <div class="steps_title">跟单员：{{ rs.ranSeInfo.zdrpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground">染色勾选</td>
            <td colspan="3">
              {{
                rs && rs.ranSeInfo && rs.ranSeInfo.zdrpChugang
                  ? rs.ranSeInfo.zdrpChugang == 1
                    ? "染底出缸"
                    : "套染出缸"
                  : "-"
              }}
            </td>
            <td class="greyBackground">门幅</td>
            <td colspan="3">
              {{ rs && rs.ranSeInfo && rs.ranSeInfo.zdrpMenfu ? rs.ranSeInfo.zdrpMenfu : "-" }}
            </td>
            <td class="greyBackground">克重</td>
            <td colspan="3">
              {{ rs && rs.ranSeInfo && rs.ranSeInfo.zdrpKezhong ? rs.ranSeInfo.zdrpKezhong : "-" }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 过软 -->
      <div class="reserve" v-if="gr.guoRuanInfo">
        <div class="steps_line">
          <div class="steps_title">7.过软</div>
          <div class="steps_title">跟单员：{{ gr.guoRuanInfo.ztdgpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否过软</td>
            <td colspan="8">
              {{
                gr && gr.guoRuanInfo && gr.guoRuanInfo.ztdgpGuoruan
                  ? gr.guoRuanInfo.ztdgpGuoruan == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">备注</td>
            <td colspan="8">
              {{
                gr && gr.guoRuanInfo && gr.guoRuanInfo.ztdgpRemarks
                  ? gr.guoRuanInfo.ztdgpRemarks
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 理压或脱水 -->
      <div class="reserve" v-if="ly.liYaInfo">
        <div class="steps_line">
          <div class="steps_title">8.理压或脱水</div>
          <div class="steps_title">跟单员：{{ ly.liYaInfo.ztdlpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否理压或脱水</td>
            <td colspan="8">
              {{
                ly && ly.liYaInfo && ly.liYaInfo.ztdlpLiya
                  ? ly.liYaInfo.ztdlpLiya == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 破幅（或理布） -->
      <div class="reserve" v-if="pf.poFuInfo">
        <div class="steps_line">
          <div class="steps_title">9.破幅（或理布）</div>
          <div class="steps_title">跟单员：{{ pf.poFuInfo.ztdfoPofuFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否破幅（或理布）</td>
            <td colspan="8">
              {{
                pf && pf.poFuInfo && pf.poFuInfo.ztdfoPofuStatus
                  ? pf.poFuInfo.ztdfoPofuStatus == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 水洗 -->
      <div class="reserve" v-if="sx.shuiXiInfo">
        <div class="steps_line">
          <div class="steps_title">10.水洗</div>
          <div class="steps_title">跟单员：{{ sx.shuiXiInfo.ztdsxpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否水洗</td>
            <td colspan="8">
              {{
                sx && sx.shuiXiInfo && sx.shuiXiInfo.ztdsxpShuixi
                  ? sx.shuiXiInfo.ztdsxpShuixi == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 干布 -->
      <div class="reserve" v-if="ganBu.ganBuInfo">
        <div class="steps_line">
          <div class="steps_title">11.干布</div>
          <div class="steps_title">跟单员：{{ ganBu.ganBuInfo.ztdgbpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否干布</td>
            <td colspan="9">
              {{
                ganBu && ganBu.ganBuInfo && ganBu.ganBuInfo.ztdgbpGanbu
                  ? ganBu.ganBuInfo.ztdgbpGanbu == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 成定 -->
      <div class="chengDing" v-if="chengDingInfo.ztdcpMachineSpeed">
        <div class="steps_line">
          <div class="steps_title">12.成定</div>
          <div class="steps_title">跟单员：{{ chengDingInfo.ztdcpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground">车速</td>
            <td colspan="4">
              {{
                chengDingInfo && chengDingInfo.ztdcpMachineSpeed
                  ? chengDingInfo.ztdcpMachineSpeed
                  : "-"
              }}
            </td>
            <td class="greyBackground">温度</td>
            <td colspan="5">
              {{
                chengDingInfo && chengDingInfo.ztdcpMachineTemperature
                  ? chengDingInfo.ztdcpMachineTemperature
                  : "-"
              }}
            </td>
          </tr>
          <template v-for="(item, index) in JSON.parse(chengDingInfo.ztdcpMachineAuxiliary)">
            <tr :key="item.auxiliary">
              <td class="greyBackground">助剂{{ index + 1 }}</td>
              <td colspan="4">{{ item.auxiliary ? item.auxiliary : "-" }}</td>
              <td class="greyBackground">助剂{{ index + 1 }}信息</td>
              <td colspan="5">{{ item.auxiliaryInfo ? item.auxiliaryInfo : "-" }}</td>
            </tr>
          </template>
          <tr>
            <td class="greyBackground" rowspan="2">上机</td>
            <td class="greyBackground">门幅(cm)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpUpMachineLarghezza
                  ? chengDingInfo.ztdcpUpMachineLarghezza
                  : "-"
              }}
            </td>
            <td class="greyBackground" rowspan="2">定中</td>
            <td class="greyBackground">门幅(cm)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpMiddleMachineLarghezza
                  ? chengDingInfo.ztdcpMiddleMachineLarghezza
                  : "-"
              }}
            </td>
            <td class="greyBackground" rowspan="2">下机</td>
            <td class="greyBackground">门幅(cm)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpDownMachineLarghezza
                  ? chengDingInfo.ztdcpDownMachineLarghezza
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">克重(GSM)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpUpMachineGram
                  ? chengDingInfo.ztdcpUpMachineGram
                  : "-"
              }}
            </td>
            <td class="greyBackground">克重(GSM)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpMiddleMachineGram
                  ? chengDingInfo.ztdcpMiddleMachineGram
                  : "-"
              }}
            </td>
            <td class="greyBackground">克重(GSM)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpDownMachineGram
                  ? chengDingInfo.ztdcpDownMachineGram
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" rowspan="2">图片</td>
            <td colspan="10" rowspan="2">
              <img
                v-for="item in imgList && imgList.imgList_cd ? imgList.imgList_cd : []"
                :key="item"
                :src="baseUrl + item"
                alt=""
              />
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td class="greyBackground">备注</td>
            <td colspan="10">
              {{
                chengDingInfo && chengDingInfo.ztdcpOtherRemarks
                  ? chengDingInfo.ztdcpOtherRemarks
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">缩率要求</td>
            <td class="greyBackground">直缩(%)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpStraightContraction
                  ? chengDingInfo.ztdcpStraightContraction
                  : "-"
              }}
            </td>
            <td class="greyBackground">横缩(%)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpTransverseContraction
                  ? chengDingInfo.ztdcpTransverseContraction
                  : "-"
              }}
            </td>
            <td class="greyBackground">平纹(%)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpPlainWeave ? chengDingInfo.ztdcpPlainWeave : "-"
              }}
            </td>
            <td class="greyBackground">扭度(%)</td>
            <td>
              {{ chengDingInfo && chengDingInfo.ztdcpTwist ? chengDingInfo.ztdcpTwist : "-" }}
            </td>
            <td class="greyBackground">PH值</td>
            <td>{{ chengDingInfo && chengDingInfo.ztdcpPh ? chengDingInfo.ztdcpPh : "-" }}</td>
          </tr>
          <tr>
            <td class="greyBackground">色牢度要求</td>
            <td class="greyBackground">水洗(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpWashing ? chengDingInfo.ztdcpWashing : "-"
                )
              }}
            </td>
            <td class="greyBackground">干磨(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpDryFriction
                    ? chengDingInfo.ztdcpDryFriction
                    : "-"
                )
              }}
            </td>
            <td class="greyBackground">湿磨(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpWetFriction
                    ? chengDingInfo.ztdcpWetFriction
                    : "-"
                )
              }}
            </td>
            <td class="greyBackground">光照(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpIllumination
                    ? chengDingInfo.ztdcpIllumination
                    : "-"
                )
              }}
            </td>
            <td class="greyBackground">汗渍(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpSweatStain
                    ? chengDingInfo.ztdcpSweatStain
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">手感要求</td>
            <td colspan="4">
              {{
                chengDingInfo && chengDingInfo.ztdcpHandleRequirements
                  ? chengDingInfo.ztdcpHandleRequirements
                  : "-"
              }}
            </td>
            <td class="greyBackground">对色光源</td>
            <td colspan="5">
              {{
                chengDingInfo && chengDingInfo.ztdcpColorSource
                  ? chengDingInfo.ztdcpColorSource
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground">合理损耗及计算方法</td>
            <td colspan="10">
              {{
                chengDingInfo && chengDingInfo.ztdcpReasonableLoss
                  ? chengDingInfo.ztdcpReasonableLoss
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 后整理 -->
      <div class="reserve" v-if="houZhengli.houZhengLiInfo">
        <div class="steps_line">
          <div class="steps_title">13.后整理</div>
          <div class="steps_title">
            跟单员：{{ houZhengli.houZhengLiInfo.ztdhpFollower || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否剪毛</td>
            <td colspan="9">
              {{
                houZhengli && houZhengli.houZhengLiInfo && houZhengli.houZhengLiInfo.ztdhpJianmao
                  ? houZhengli.houZhengLiInfo.ztdhpJianmao == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">是否预缩</td>
            <td colspan="9">
              {{
                houZhengli && houZhengli.houZhengLiInfo && houZhengli.houZhengLiInfo.ztdhpGuoyusuoji
                  ? houZhengli.houZhengLiInfo.ztdhpGuoyusuoji == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">备注</td>
            <td colspan="9">
              {{
                houZhengli && houZhengli.houZhengLiInfo && houZhengli.houZhengLiInfo.ztdhpRemarks
                  ? houZhengli.houZhengLiInfo.ztdhpRemarks
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 染厂/定型厂/打包进仓 -->
      <div class="reserve" v-if="daBao.daBaoInfo">
        <div class="steps_line">
          <div class="steps_title">14.染厂/定型厂/打包进仓</div>
          <div class="steps_title">跟单员：{{ daBao.daBaoInfo.ztddpFollower || "--" }}</div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">总米数</td>
            <td colspan="3">
              {{
                daBao && daBao.daBaoInfo && daBao.daBaoInfo.ztddpPishu
                  ? daBao.daBaoInfo.ztddpPishu
                  : "-"
              }}
            </td>
            <td class="greyBackground" style="width:220px">总公斤数</td>
            <td colspan="3">
              {{
                daBao && daBao.daBaoInfo && daBao.daBaoInfo.ztddpGongjing
                  ? daBao.daBaoInfo.ztddpGongjing
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" rowspan="2">图片</td>
            <td colspan="8" rowspan="2">
              <img
                v-for="item in daBao && daBao.imgList ? daBao.imgList : []"
                :key="item"
                :src="baseUrl + item"
              />
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td class="greyBackground">备注</td>
            <td colspan="8">
              {{
                daBao && daBao.daBaoInfo && daBao.daBaoInfo.ztddpRemarks
                  ? daBao.daBaoInfo.ztddpRemarks
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 是否提供船样给业务确认信息 -->
      <div class="reserve" v-if="chuanYang.chuanYangInfo">
        <div class="steps_line">
          <div class="steps_title">15.是否提供船样给业务确认信息</div>
          <div class="steps_title">
            跟单员：{{ chuanYang.chuanYangInfo.ztdcypFollower || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">是否提供船样给业务确认信息</td>
            <td colspan="9">
              {{
                chuanYang && chuanYang.chuanYangInfo && chuanYang.chuanYangInfo.ztdcypStatus
                  ? chuanYang.chuanYangInfo.ztdcypStatus == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 业务确认 -->
      <div class="businessConfirm" v-if="businessConfirmInfo.status">
        <div class="steps_line">
          <div class="steps_title">16.业务确认</div>
          <div class="steps_title">
            跟单员：{{ businessConfirmInfo.ztdfoYewuquerenFollower || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  businessConfirmInfo && businessConfirmInfo.status
                    ? businessConfirmInfo.status
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">审核意见</td>
            <td colspan="9">
              {{
                businessConfirmInfo && businessConfirmInfo.ztdfoBusinessReviewComments
                  ? businessConfirmInfo.ztdfoBusinessReviewComments
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" rowspan="2" style="width:220px">照片</td>
            <td rowspan="2" colspan="9">
              <img
                v-for="item in imgList && imgList.imgList_bc ? imgList.imgList_bc : []"
                :key="item"
                :src="baseUrl + item"
                alt=""
              />
            </td>
          </tr>
          <tr></tr>
        </table>
      </div>
      <!-- 解决方案1 -->
      <div class="businessConfirm" v-if="fangAn1.fangAn1Info">
        <div class="steps_line">
          <div class="steps_title">17.解决方案</div>
          <div class="steps_title">
            跟单员：{{ fangAn1.fangAn1Info.ztdfoSolutionFollower1 || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">解决方案</td>
            <td colspan="9">
              {{
                fangAn1.fangAn1Info && fangAn1.fangAn1Info.ztdfoSolutionComments1
                  ? fangAn1.fangAn1Info.ztdfoSolutionComments1
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 业务确认1 -->
      <div class="businessConfirm" v-if="yeWu1.yeWu1Info">
        <div class="steps_line">
          <div class="steps_title">18.业务确认</div>
          <div class="steps_title">
            跟单员：{{ yeWu1.yeWu1Info.ztdfoBusinessConfirmationFollower1 || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  yeWu1.yeWu1Info && yeWu1.yeWu1Info.ztdfoBusinessConfirmationStatus1
                    ? yeWu1.yeWu1Info.ztdfoBusinessConfirmationStatus1
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">审核意见</td>
            <td colspan="9">
              {{
                yeWu1.yeWu1Info && yeWu1.yeWu1Info.ztdfoBusinessReviewComments1
                  ? yeWu1.yeWu1Info.ztdfoBusinessReviewComments1
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 解决方案2 -->
      <div class="businessConfirm" v-if="fangAn2.fangAn2Info">
        <div class="steps_line">
          <div class="steps_title">19.解决方案</div>
          <div class="steps_title">
            跟单员：{{ fangAn2.fangAn2Info.ztdfoSolutionFollower2 || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">解决方案</td>
            <td colspan="9">
              {{
                fangAn2.fangAn2Info && fangAn2.fangAn2Info.ztdfoSolutionComments2
                  ? fangAn2.fangAn2Info.ztdfoSolutionComments2
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 业务确认2 -->
      <div class="businessConfirm" v-if="yeWu2.yeWu2Info">
        <div class="steps_line">
          <div class="steps_title">20.业务确认</div>
          <div class="steps_title">
            跟单员：{{ yeWu2.yeWu2Info.ztdfoBusinessConfirmationFollower2 || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  yeWu2.yeWu2Info && yeWu2.yeWu2Info.ztdfoBusinessConfirmationStatus2
                    ? yeWu2.yeWu2Info.ztdfoBusinessConfirmationStatus2
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">审核意见</td>
            <td colspan="9">
              {{
                yeWu2.yeWu2Info && yeWu2.yeWu2Info.ztdfoBusinessReviewComments2
                  ? yeWu2.yeWu2Info.ztdfoBusinessReviewComments2
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 解决方案3 -->
      <div class="businessConfirm" v-if="fangAn3.fangAn3Info">
        <div class="steps_line">
          <div class="steps_title">21.解决方案</div>
          <div class="steps_title">
            跟单员：{{ fangAn3.fangAn3Info.ztdfoSolutionFollower3 || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">解决方案</td>
            <td colspan="9">
              {{
                fangAn3.fangAn3Info && fangAn3.fangAn3Info.ztdfoSolutionComments3
                  ? fangAn3.fangAn3Info.ztdfoSolutionComments3
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 业务确认3 -->
      <div class="businessConfirm" v-if="yeWu3.yeWu3Info">
        <div class="steps_line">
          <div class="steps_title">22.业务确认</div>
          <div class="steps_title">
            跟单员：{{ yeWu3.yeWu3Info.ztdfoBusinessConfirmationFollower3 || "--" }}
          </div>
        </div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" style="width:220px">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  yeWu3.yeWu3Info && yeWu3.yeWu3Info.ztdfoBusinessConfirmationStatus3
                    ? yeWu3.yeWu3Info.ztdfoBusinessConfirmationStatus3
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="greyBackground" style="width:220px">审核意见</td>
            <td colspan="9">
              {{
                yeWu3.yeWu3Info && yeWu3.yeWu3Info.ztdfoBusinessReviewComments3
                  ? yeWu3.yeWu3Info.ztdfoBusinessReviewComments3
                  : "-"
              }}
            </td>
          </tr>
        </table>
      </div>
      <!-- 二次成定 -->
      <!-- <div class="chengDing" v-if="chengDingInfo_second">
        <div class="steps_title">5.二次成定</div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground">车速</td>
            <td colspan="4">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpMachineSpeed)?chengDingInfo_second.ztdcpMachineSpeed:'-'}}</td>
            <td class="greyBackground">温度</td>
            <td colspan="5">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpMachineTemperature)?chengDingInfo_second.ztdcpMachineTemperature:'-'}}</td>
          </tr>
          <template v-for="(item,index) in JSON.parse(chengDingInfo_second.ztdcpMachineAuxiliary)">
          <tr :key="item">
            <td class="greyBackground">助剂{{index+1}}</td>
            <td colspan="4">{{item.auxiliary?item.auxiliary:'-'}}</td>
            <td class="greyBackground">助剂{{index+1}}信息</td>
            <td colspan="5">{{item.auxiliaryInfo?item.auxiliaryInfo:'-'}}</td>
          </tr>
          </template>
          <tr>
            <td class="greyBackground" rowspan="2">上机</td>
            <td class="greyBackground">门幅(cm)</td>
            <td colspan="2">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpUpMachineLarghezza)?chengDingInfo_second.ztdcpUpMachineLarghezza:'-'}}</td>
            <td class="greyBackground" rowspan="2">定中</td>
            <td class="greyBackground">门幅(cm)</td>
            <td colspan="2">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpMiddleMachineLarghezza)?chengDingInfo_second.ztdcpMiddleMachineLarghezza:'-'}}</td>
            <td class="greyBackground" rowspan="2">下机</td>
            <td class="greyBackground">门幅(cm)</td>
            <td colspan="2">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpDownMachineLarghezza)?chengDingInfo_second.ztdcpDownMachineLarghezza:'-'}}</td>
          </tr>
          <tr>
            <td class="greyBackground">克重(GSM)</td>
            <td colspan="2">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpUpMachineGram)?chengDingInfo_second.ztdcpUpMachineGram:'-'}}</td>
            <td class="greyBackground">克重(GSM)</td>
            <td colspan="2">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpMiddleMachineGram)?chengDingInfo_second.ztdcpMiddleMachineGram:'-'}}</td>
            <td class="greyBackground">克重(GSM)</td>
            <td colspan="2">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpDownMachineGram)?chengDingInfo_second.ztdcpDownMachineGram:'-'}}</td>
          </tr>
          <tr>
            <td class="greyBackground" rowspan="2">图片</td>
            <td colspan="10" rowspan="2">
              <img v-for="item in (imgList&&imgList.imgList_cd_second)?imgList.imgList_cd_second:[]" :key="item" :src="baseUrl+item" alt=""/>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td class="greyBackground">备注</td>
            <td colspan="10">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpOtherRemarks)?chengDingInfo_second.ztdcpOtherRemarks:'-'}}</td>
          </tr>
          <tr>
            <td class="greyBackground">缩率要求</td>
            <td class="greyBackground">直缩(%)</td>
            <td>{{(chengDingInfo_second&&chengDingInfo_second.ztdcpStraightContraction)?chengDingInfo_second.ztdcpStraightContraction:'-'}}</td>
            <td class="greyBackground">横缩(%)</td>
            <td>{{(chengDingInfo_second&&chengDingInfo_second.ztdcpTransverseContraction)?chengDingInfo_second.ztdcpTransverseContraction:'-'}}</td>
            <td class="greyBackground">平纹(%)</td>
            <td>{{(chengDingInfo_second&&chengDingInfo_second.ztdcpPlainWeave)?chengDingInfo_second.ztdcpPlainWeave:'-'}}</td>
            <td class="greyBackground">扭度(%)</td>
            <td>{{(chengDingInfo_second&&chengDingInfo_second.ztdcpTwist)?chengDingInfo_second.ztdcpTwist:'-'}}</td>
            <td class="greyBackground">PH值</td>
            <td>{{(chengDingInfo_second&&chengDingInfo_second.ztdcpPh)?chengDingInfo_second.ztdcpPh:'-'}}</td>
          </tr>
          <tr>
            <td class="greyBackground">色牢度要求</td>
            <td class="greyBackground">水洗(级)</td>
            <td>{{chooseGrade((chengDingInfo_second&&chengDingInfo_second.ztdcpWashing)?chengDingInfo_second.ztdcpWashing:'-')}}</td>
            <td class="greyBackground">干磨(级)</td>
            <td>{{chooseGrade((chengDingInfo_second&&chengDingInfo_second.ztdcpDryFriction)?chengDingInfo_second.ztdcpDryFriction:'-')}}</td>
            <td class="greyBackground">湿磨(级)</td>
            <td>{{chooseGrade((chengDingInfo_second&&chengDingInfo_second.ztdcpWetFriction)?chengDingInfo_second.ztdcpWetFriction:'-')}}</td>
            <td class="greyBackground">光照(级)</td>
            <td>{{chooseGrade((chengDingInfo_second&&chengDingInfo_second.ztdcpIllumination)?chengDingInfo_second.ztdcpIllumination:'-')}}</td>
            <td class="greyBackground">汗渍(级)</td>
            <td>{{chooseGrade((chengDingInfo_second&&chengDingInfo_second.ztdcpSweatStain)?chengDingInfo_second.ztdcpSweatStain:'-')}}</td>
          </tr>
          <tr>
            <td class="greyBackground">手感要求</td>
            <td colspan="4">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpHandleRequirements)?chengDingInfo_second.ztdcpHandleRequirements:'-'}}</td>
            <td class="greyBackground">对色光源</td>
            <td colspan="5">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpColorSource)?chengDingInfo_second.ztdcpColorSource:'-'}}</td>
          </tr>
          <tr>
            <td class="greyBackground">合理损耗及计算方法</td>
            <td colspan="10">{{(chengDingInfo_second&&chengDingInfo_second.ztdcpReasonableLoss)?chengDingInfo_second.ztdcpReasonableLoss:'-'}}</td>
          </tr>
        </table>
      </div> -->
      <!-- 二次业务确认 -->
      <!-- <div class="businessConfirm" v-if="chengDingInfo_second">
        <div class="steps_title">6.二次业务确认</div>
        <table cellspacing="0" class="steps_table">
          <tr>
            <td class="greyBackground" :style="businessConfirmInfo_second.status===2?'width:220px;color:#FF6D26;':'width:220px;'">审核结果</td>
            <td colspan="9">{{chooseConfirm((businessConfirmInfo_second&&businessConfirmInfo_second.status)?businessConfirmInfo_second.status:'-')}}</td>
          </tr>
          <tr>
            <td class="greyBackground"  style="width:220px">审核意见</td>
            <td colspan="9">{{(businessConfirmInfo_second&&businessConfirmInfo_second.ztdfoBusinessReviewComments)?businessConfirmInfo_second.ztdfoBusinessReviewComments:'-'}}</td>
          </tr>
          <tr>
            <td class="greyBackground"  style="width:220px" rowspan="2">照片</td>
            <td rowspan="2" colspan="9">
              <img v-for="item in (imgList&&imgList.imgList_bc_second)?imgList.imgList_bc_second:[]" :key="item" :src="baseUrl+item" alt=""/>
            </td>
          </tr>
          <tr></tr>
        </table>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      grepclothComfir: {}, // 胚布确认信息
      yuDingInfo: {}, // 预定信息
      chengDingInfo: {}, // 成定信息
      businessConfirmInfo: {}, // 业务信息确认
      chengDingInfo_second: {}, // 二次成定信息
      businessConfirmInfo_second: {}, // 二次业务确认
      qp: {}, // 汽平
      qcl: {}, // 前处理
      rs: {}, // 染色
      gr: {}, // 过软
      ly: {}, // 理压
      sx: {}, // 水洗
      daBao: {}, // 染厂/定型厂/打包进仓
      chuanYang: {}, // 是否提供船样给业务确认信息
      ganBu: {}, // 干布
      pf: {}, // 破幅（或理布）
      yeWu1: {}, // 业务处理1
      yeWu2: {}, // 业务处理2
      yeWu3: {}, // 业务处理3
      fangAn1: {}, // 解决方案1
      fangAn2: {}, // 解决方案2
      fangAn3: {}, // 解决方案3
      houZhengli: {},
      imgList: {} // 图片数组
    };
  },
  created() {
    this.getOrderStatus();
  },
  methods: {
    // 选择级数
    chooseGrade(value) {
      switch (value) {
        case 1:
          return "一级";
        case 2:
          return "二级";
        case 3:
          return "三级";
        case 4:
          return "四级";
        case 5:
          return "五级";
        case 6:
          return "六级";
        case 7:
          return "七级";
        case 8:
          return "八级";
        default:
          return "-";
      }
    },
    // 选择审核结果
    chooseConfirm(value) {
      switch (value) {
        case 0:
          return "待确认";
        case 1:
          return "通过";
        case 2:
          return "不通过";
        default:
          return "-";
      }
    },
    // 选择当前步骤
    chooseStatus() {
      switch (this.$route.query.ztdpoStatus) {
        case "0":
          return "待胚布确认";
        case "1":
          return "待缝头";
        case "2":
          return "待汽平";
        case "3":
          return "待预定";
        case "4":
          return "待前处理";
        case "5":
          return "待染色";
        case "6":
          return "待过软";
        case "7":
          return "待理压脱水";
        case "8":
          return "待破幅";
        case "9":
          return "待水洗";
        case "10":
          return "待干布";
        case "11":
          return "待成定";
        case "12":
          return "待后整理";
        case "13":
          return "待进仓";
        case "14":
          return "待提供业务确认";
        case "15":
          return "待业务确认";
        case "16":
          return "待回仓";
        case "17":
          return "已完成";
        default:
          return "未知";
      }
    },
    // 获取订单详情信息
    getOrderStatus() {
      this.axios({
        url: "/dtsum/zongtong/dyeing/WebDyeingController/dyeingPlanOrderSheetInfo",
        method: "get",
        params: {
          params: {
            dyeingOrderNumber: this.$route.query.dyeingOrderNumber,
            contractNo: this.$route.query.contract,
            followerName: this.$route.query.followerName,
            ztdpoStatus: this.$route.query.ztdpoStatus
          }
        }
      })
        .then(res => {
          if (res.data.success === 1) {
            const body = res.data.body;
            this.grepclothComfir = JSON.parse(JSON.stringify(body.grepclothComfir));
            this.yuDingInfo = JSON.parse(JSON.stringify(body.yuDingInfo));
            this.chengDingInfo = JSON.parse(JSON.stringify(body.chengDingInfo));
            this.businessConfirmInfo = JSON.parse(JSON.stringify(body.businessConfirmInfo));
            this.qp = JSON.parse(JSON.stringify(body.qp));
            this.qcl = JSON.parse(JSON.stringify(body.qcl));
            this.rs = JSON.parse(JSON.stringify(body.rs));
            this.gr = JSON.parse(JSON.stringify(body.gr));
            this.ly = JSON.parse(JSON.stringify(body.ly));
            this.sx = JSON.parse(JSON.stringify(body.sx));
            this.ganBu = JSON.parse(JSON.stringify(body.ganBu));
            this.houZhengli = JSON.parse(JSON.stringify(body.houZhengli));
            this.daBao = JSON.parse(JSON.stringify(body.daBao));
            this.chuanYang = JSON.parse(JSON.stringify(body.chuanYang));
            this.pf = JSON.parse(JSON.stringify(body.pf));
            this.yeWu1 = JSON.parse(JSON.stringify(body.yeWu1));
            this.yeWu2 = JSON.parse(JSON.stringify(body.yeWu2));
            this.yeWu3 = JSON.parse(JSON.stringify(body.yeWu3));
            this.fangAn1 = JSON.parse(JSON.stringify(body.fangAn1));
            this.fangAn2 = JSON.parse(JSON.stringify(body.fangAn2));
            this.fangAn3 = JSON.parse(JSON.stringify(body.fangAn3));
            // this.chengDingInfo_second = JSON.parse(JSON.stringify(body.chengDingInfo_second))
            // this.businessConfirmInfo_second = JSON.parse(JSON.stringify(body.businessConfirmInfo_second))
            this.imgList = JSON.parse(JSON.stringify(body.imgList));
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
>
<style lang="scss" scoped>
.dyeingAndFinishingOrderDetail {
  font-family: Source Han Sans CN;
  img {
    width: 80px;
    // height:80px;
    margin-right: 10px;
  }
  img:hover {
    transition-property: transform;
    transition-duration: 200ms;
    transition-timing-function: ease-in-out;
    transform: scale(6);
  }
  .header {
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    .header_title {
      display: flex;
      align-items: center;
      .block {
        width: 4px;
        height: 20px;
        background: #256de6;
        margin-right: 9px;
      }
    }
    .header_message {
      display: flex;
      justify-content: flex-end;
      .header_right {
        display: flex;
        height: 30px;
        line-height: 30px;
        color: #256de6;
        &:nth-child(1) {
          margin-right: 54px;
        }
        div {
          &:nth-child(1) {
            margin-right: 12px;
            font-size: 14px;
            color: rgba(51, 51, 51, 0.65);
          }
        }
      }
    }
  }
  .steps {
    .steps_line {
      display: flex;
      justify-content: space-between;
    }
    .steps_title {
      margin-top: 30px;
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
    }
    .steps_table {
      width: 100%;
      border: 1px solid #b3a2a2;
      border-collapse: collapse;
      color: rgba(51, 51, 51, 0.85);
      tr {
        height: 60px;
        td {
          padding: 0px 20px;
          border: 1px solid #dcdada;
        }
        .greyBackground {
          background: #f5f5f5;
          font-weight: 500;
          color: #333333;
        }
      }
    }
    .businessConfirm {
      .greyBackground {
        max-width: 170px;
      }
    }
  }
}
</style>
